var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1920,
    height: 960,
    viewBox: "0 0 1920 960",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 960,
    fill: "#F7B500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2031 585.5C2031 826.399 1666.22 804.353 1503.5 1012C1284.82 1291.07 1325.47 1621 994 1621C421.281 1621 -43 1157.39 -43 585.5C-43 13.6091 421.281 -450 994 -450C1566.72 -450 2031 13.6091 2031 585.5Z",
    fill: "#1681F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2074 164.5C2074 405.399 1709.22 383.353 1546.5 591C1327.82 870.066 1368.47 1200 1037 1200C464.281 1200 0 736.391 0 164.5C0 -407.391 464.281 -871 1037 -871C1609.72 -871 2074 -407.391 2074 164.5Z",
    fill: "#0366D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1533 82.5C1533 339.229 1124 389 991 745C893.389 1006.28 648.979 1066 353 1066C-199.837 1066 -469 635.061 -469 82.5C-469 -470.061 -20.837 -918 532 -918C1084.84 -918 1533 -470.061 1533 82.5Z",
    fill: "#0E3C6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.189 -309.348C511.426 -121.862 222.401 -5.46172 194.909 280.552C174.733 490.464 7.88503 581.918 -208.321 639.85C-612.155 748.057 -893.098 486.032 -1001.22 82.5038C-1109.35 -321.024 -869.628 -735.867 -465.794 -844.074C-61.9603 -952.281 353.064 -712.876 461.189 -309.348Z",
    fill: "#15375C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 960,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgLogin);
export default __webpack_public_path__ + "static/media/bg-login.8d552a1fee22672f58e761217baab8b8.svg";
export { ForwardRef as ReactComponent };